import React from "react"

const Keywords = ({ title, words }) => {
  return (
    <div className="ketwords-container">
      <h2>{title}:</h2>
      <h3>{words}.</h3>
    </div>
  )
}
export default Keywords
